<template>
  <div v-rect-loading="loading" class="personal-profile-page">
    <div class="header">{{ $t(`${i18nPrefix}.label.myProfile`) }}</div>
    <i class="edit-icon iconfont iconEditor" @click="handleEditResume"></i>
    <ResumeInfo
      class="resume-info"
      ref="resumeInfo"
      @load="changeLoading"
    />
  </div>
</template>

<script>
import ResumeInfo from '@/components/candidate/mobile/resumeInfo.vue'

export default {
  components: {
    ResumeInfo
  },
  props: {
    personalInfo: {
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.profile',
      loading: false
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    if (this.personalInfo.profile_step === 1 || this.personalInfo.need_to_finish_profile) {
      this.$router.replace({ path: '/recruiting/personal/resume/add', query: { back: this.$route.fullPath, company_id: this.companyId } })
    }
  },
  mounted () {

  },
  methods: {
    handleEditResume () {
      this.$router.push({ path: '/recruiting/personal/resume/edit', query: { back: this.$route.fullPath, company_id: this.companyId } })
    },
    handlePersonalHome () {
      this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
    },
    changeLoading (loading) {
      this.loading = loading
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-profile-page {
  position: relative;

  .header {
    text-align: center;
    line-height: 24px;
    font-size: 16px;
    color: #333;
  }

  .edit-icon {
    font-size: 18px;
    position: absolute;
    top: 58px;
    right: 28px;
    color: var(--custom-color,#0096cc)
  }

  .resume-info {
    margin-top: 14px;
  }
}
</style>
